export default "__VITE_ASSET__DmE9H14b__"